module.exports = require('./uploadredirect');
